import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar, NavLink } from "react-bootstrap";
import weShare from "../../../images/We_Share.png";
import hamburger from "../../../images/hamburger.svg";
import "./NavbarMenu.css";
import SearchOption from "./SearchOption";
import { Link } from "react-router-dom";

const NavbarMenu = () => {
  const [navbar, setNavbar] = useState(false);

  useEffect(() => {
    const changeBackground = () => {
      if (window.scrollY >= 10) {
        setNavbar(true);
      } else {
        setNavbar(false);
      }
    };
    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  return (
    <div className="position-fixed w-100" style={{ zIndex: 30 }}>
      <Navbar variant="dark" expand="lg" className={navbar ? "active" : ""}>
        <Container className={navbar ? "smallScreenPadding w-100" : "w-100"}>
          <Navbar.Brand>
            <div className="d-flex align-items-center">
              <Link to="/">
                <div className="nav_logo">
                  <img className="weShare" src={weShare} alt="weShare" />
                </div>
              </Link>
              <div
                className={
                  !navbar
                    ? "categories_btn"
                    : "categories_btn_after text-dark border-dark categories_btn"
                }
              >
                <label className="mb-0">Categories</label>
                <select
                  className={
                    !navbar ? "fa ps-2" : "border-0 text-secondary fa ps-2"
                  }
                >
                  <option value="fa fa-angle-down">&#xf107;</option>
                </select>
              </div>
              <div
                className={
                  navbar
                    ? "lenActive d-flex align-items-center"
                    : "len d-flex align-items-center"
                }
              >
                <svg
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="presentation"
                  focusable="false"
                  style={{
                    display: "block",
                    height: "20px",
                    width: "20px",
                    fill: "currentcolor",
                    cursor: "pointer",
                  }}
                >
                  <path d="m8.002.25a7.77 7.77 0 0 1 7.748 7.776 7.75 7.75 0 0 1 -7.521 7.72l-.246.004a7.75 7.75 0 0 1 -7.73-7.513l-.003-.245a7.75 7.75 0 0 1 7.752-7.742zm1.949 8.5h-3.903c.155 2.897 1.176 5.343 1.886 5.493l.068.007c.68-.002 1.72-2.365 1.932-5.23zm4.255 0h-2.752c-.091 1.96-.53 3.783-1.188 5.076a6.257 6.257 0 0 0 3.905-4.829zm-9.661 0h-2.75a6.257 6.257 0 0 0 3.934 5.075c-.615-1.208-1.036-2.875-1.162-4.686l-.022-.39zm1.188-6.576-.115.046a6.257 6.257 0 0 0 -3.823 5.03h2.75c.085-1.83.471-3.54 1.059-4.81zm2.262-.424c-.702.002-1.784 2.512-1.947 5.5h3.904c-.156-2.903-1.178-5.343-1.892-5.494l-.065-.007zm2.28.432.023.05c.643 1.288 1.069 3.084 1.157 5.018h2.748a6.275 6.275 0 0 0 -3.929-5.068z"></path>
                </svg>
                <span className="lenguage">EN</span>
              </div>
            </div>
          </Navbar.Brand>
          <div>
            <div>
              <div className="btn-group">
                <img
                  className={
                    !navbar
                      ? "dropdown-toggle hamburger"
                      : "hamburgerAfter dropdown-toggle"
                  }
                  data-bs-toggle="dropdown"
                  data-bs-display="static"
                  aria-expanded="false"
                  src={hamburger}
                  alt=""
                />
                <ul
                  className={
                    !navbar
                      ? "dropdown-menu"
                      : "active_dropdown-menu dropdown-menu"
                  }
                >
                  <Nav.Link className="text-white nav_link">
                    How it works
                  </Nav.Link>
                  <Nav.Link className="text-white nav_link ">
                    Become a host
                  </Nav.Link>
                  <NavLink>
                    <div
                      className="list_items_btn_mobile"
                      style={{ display: "block" }}
                    >
                      <button>List An Item</button>
                    </div>
                  </NavLink>
                  <Nav.Link className="text-white nav_link ">
                    <button
                      className={
                        navbar
                          ? "nav_btn btn_active pt-2 bolder"
                          : "nav_btn text-black border-dark"
                      }
                    >
                      Login
                    </button>
                    <div className="pt-2 ">
                      <button
                        className={
                          navbar
                            ? "nav_btn btn_active bolder active"
                            : "nav_btn text-black border-dark "
                        }
                      >
                        Sign Up
                      </button>
                    </div>
                  </Nav.Link>
                </ul>
              </div>
            </div>
          </div>
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="ms-auto my-2 d-flex align-items-center"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
              {!navbar ? (
                <>
                  <Nav.Link className="nav_link">How it works</Nav.Link>
                  <div className="margin borderNav"></div>
                  <Nav.Link className="nav_link text-white ">
                    Become a host
                  </Nav.Link>
                  <div className="margin borderNav ms-2"></div>
                </>
              ) : (
                <div className="navSearchDistop">
                  <SearchOption />
                </div>
              )}

              <Nav.Link className="text-white nav_link">
                <button
                  className={
                    !navbar ? "nav_btn_login me-3" : "nav_btn_login_active me-3"
                  }
                >
                  Login
                </button>
                <button className={navbar ? "nav_btn btn_active" : "nav_btn"}>
                  Sign Up
                </button>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <>
        {navbar && (
          <div className="navSearchMobile">
            <SearchOption />
          </div>
        )}
      </>
    </div>
  );
};

export default NavbarMenu;
